import { getApiUrl, tokenInterceptor, paramsSerializer } from '@app/api';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const usageStatsApi = createApi({
  reducerPath: 'usageStatsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: getApiUrl('/stats'),
    prepareHeaders: tokenInterceptor,
    paramsSerializer,
  }),
  tagTypes: ['UsageStats'],
  endpoints: (builder) => ({
    usageStats: builder.mutation({
      query: (obj) => ({
        url: `usage`,
        method: 'POST',
        body: {
          ...{ ...obj, countries: undefined },
          time_stamp: new Date().getTime(),
        },
      }),
      providesTags: ['UsageStats'],
    }),
  }),
});

export const { useUsageStatsMutation } = usageStatsApi;
